import { useQuery } from '@apollo/react-hooks';
import type { ApolloClient, ApolloError } from 'apollo-client';
import differenceInDays from 'date-fns/differenceInDays';

import { TrialDetailsQuery } from './constants';

export const useGetTrialData = ({
	client,
	experimentName,
	skip = false,
}: {
	client: ApolloClient<object>;
	experimentName: string;
	skip?: boolean;
}): {
	error?: ApolloError;
	loading: boolean;
	trialEndDate?: string;
	daysLeftInTrial?: number;
	billingSystem?: string;
} => {
	const { data, loading, error } = useQuery(TrialDetailsQuery(experimentName), {
		skip,
		client,
	});

	const trialEndDate = data?.license?.trialEndDate;
	const daysLeftInTrial = trialEndDate
		? differenceInDays(new Date(trialEndDate), new Date()) + 1
		: undefined;
	const billingSystem = data?.license?.billingSourceSystem;

	return {
		error,
		loading,
		trialEndDate,
		daysLeftInTrial,
		billingSystem,
	};
};
